export const translations = {
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      products: 'المنتجات',
      cart: 'السلة',
      checkout: 'الدفع',
      orders: 'طلباتي',
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      logout: 'تسجيل الخروج',
      profile: 'الملف الشخصي',
    },
    
    // Hero Section
    hero: {
      title: 'صمم مساحتك المريحة',
      subtitle: 'اكتشف أفضل المنتجات بأسعار مميزة. جودة عالية وتوصيل سريع إلى باب منزلك.',
      shopNow: 'تسوق الآن',
    },
    
    // Products
    products: {
      title: 'منتجاتنا',
      featured: 'منتجات مميزة',
      allProducts: 'جميع المنتجات',
      noProducts: 'لا توجد منتجات متطابقة',
      addToCart: 'أضف للسلة',
      outOfStock: 'نفذت الكمية',
      inStock: 'متوفر',
      sku: 'رمز المنتج',
      brand: 'العلامة التجارية',
      colors: 'الألوان',
      size: 'المقاس',
      dimensions: 'الأبعاد',
      material: 'المادة',
      quantity: 'الكمية',
      price: 'السعر',
      category: 'الفئة',
      company: 'الشركة',
      search: 'بحث',
      sortBy: 'ترتيب حسب',
      lowestPrice: 'السعر: من الأقل للأعلى',
      highestPrice: 'السعر: من الأعلى للأقل',
      nameAZ: 'الاسم (أ-ي)',
      nameZA: 'الاسم (ي-أ)',
      clearFilters: 'مسح الفلاتر',
      gridView: 'عرض شبكي',
      listView: 'عرض قائمة',
      all: 'الكل',
      quickView: 'عرض سريع',
      productsFound: 'منتجات',
      freeShipping: 'توصيل مجاني',
    },
    
    // Single Product
    singleProduct: {
      backToProducts: 'العودة للمنتجات',
      reviews: 'تقييمات',
      customerReviews: 'تقييمات العملاء',
      noReviews: 'لا توجد تقييمات بعد',
      orderNow: 'أطلب الآن',
      addToCart: 'أضف للسلة',
    },
    
    // Customer Form
    customerForm: {
      title: 'معلومات التوصيل',
      firstName: 'الاسم',
      lastName: 'اللقب',
      phone: 'رقم الهاتف',
      governorate: 'الولاية',
      city: 'المدينة',
      selectGovernorate: 'اختر الولاية',
      selectCity: 'اختر المدينة',
      phonePlaceholder: 'أدخل رقم الهاتف',
    },
    
    // Cart
    cart: {
      title: 'سلة التسوق',
      empty: 'سلتك فارغة',
      fillCart: 'أضف منتجات للسلة',
      item: 'المنتج',
      price: 'السعر',
      quantity: 'الكمية',
      subtotal: 'المجموع الفرعي',
      total: 'المجموع الكلي',
      remove: 'حذف',
      clearCart: 'تفريغ السلة',
      continueShopping: 'متابعة التسوق',
      proceedToCheckout: 'متابعة للدفع',
      shippingFee: 'رسوم التوصيل',
      orderTotal: 'إجمالي الطلب',
      free: 'مجاني',
    },
    
    // Checkout
    checkout: {
      title: 'إتمام الطلب',
      paymentMethod: 'طريقة الدفع',
      cashOnDelivery: 'الدفع عند الاستلام',
      placeOrder: 'تأكيد الطلب',
      orderSummary: 'ملخص الطلب',
      items: 'المنتجات',
      shipping: 'التوصيل',
      total: 'المجموع',
      thankYou: 'شكراً لك!',
      orderPlaced: 'تم تأكيد طلبك بنجاح',
      payOnDelivery: 'ستدفع عند الاستلام',
      redirecting: 'جاري التحويل لصفحة المنتجات',
      hello: 'مرحباً',
      yourTotal: 'المجموع الكلي',
    },
    
    // Orders
    orders: {
      title: 'طلباتي',
      noOrders: 'لا توجد طلبات',
      orderNumber: 'رقم الطلب',
      date: 'التاريخ',
      status: 'الحالة',
      total: 'المجموع',
      details: 'التفاصيل',
      processing: 'قيد المعالجة',
      shipped: 'تم الشحن',
      delivered: 'تم التوصيل',
      cancelled: 'ملغي',
    },
    
    // About
    about: {
      title: 'قصتنا',
      content: 'نحن متجر إلكتروني متخصص في تقديم أفضل المنتجات بأسعار تنافسية. نسعى دائماً لتوفير تجربة تسوق مميزة لعملائنا.',
    },
    
    // Services
    services: {
      title: 'خدماتنا',
      freeShipping: 'توصيل مجاني',
      freeShippingDesc: 'توصيل مجاني لجميع الطلبات',
      support: 'دعم على مدار الساعة',
      supportDesc: 'فريق دعم متاح دائماً لمساعدتك',
      quality: 'جودة عالية',
      qualityDesc: 'منتجات أصلية بجودة مضمونة',
    },
    
    // Contact
    contact: {
      title: 'تواصل معنا',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      message: 'الرسالة',
      send: 'إرسال',
    },
    
    // Auth
    auth: {
      login: 'تسجيل الدخول',
      register: 'إنشاء حساب',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور؟',
      resetPassword: 'إعادة تعيين كلمة المرور',
      noAccount: 'ليس لديك حساب؟',
      haveAccount: 'لديك حساب بالفعل؟',
      signInWithGoogle: 'تسجيل الدخول بـ Google',
      or: 'أو',
    },
    
    // Footer
    footer: {
      rights: 'جميع الحقوق محفوظة',
    },
    
    // Common
    common: {
      loading: 'جاري التحميل...',
      error: 'حدث خطأ',
      success: 'تمت العملية بنجاح',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تعديل',
      close: 'إغلاق',
      back: 'رجوع',
      next: 'التالي',
      previous: 'السابق',
      viewAll: 'عرض الكل',
    },
    
    // Toasts
    toasts: {
      orderSuccess: 'تم تأكيد الطلب بنجاح! سيتم الدفع عند الاستلام.',
      orderError: 'فشل في إتمام الطلب. يرجى المحاولة مرة أخرى.',
      addedToCart: 'تمت الإضافة للسلة',
      removedFromCart: 'تم الحذف من السلة',
      cartCleared: 'تم تفريغ السلة',
      loginRequired: 'يجب تسجيل الدخول أولاً',
      fillAllFields: 'يرجى ملء جميع الحقول',
    },
  },
  
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      cart: 'Cart',
      checkout: 'Checkout',
      orders: 'Orders',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      profile: 'Profile',
    },
    
    // Hero Section
    hero: {
      title: 'Design Your Comfort Zone',
      subtitle: 'Discover the best products at great prices. High quality and fast delivery to your doorstep.',
      shopNow: 'Shop Now',
    },
    
    // Products
    products: {
      title: 'Our Products',
      featured: 'Featured Products',
      allProducts: 'All Products',
      noProducts: 'No products match your search',
      addToCart: 'Add to Cart',
      outOfStock: 'Out of Stock',
      inStock: 'In Stock',
      sku: 'SKU',
      brand: 'Brand',
      colors: 'Colors',
      size: 'Size',
      dimensions: 'Dimensions',
      material: 'Material',
      quantity: 'Quantity',
      price: 'Price',
      category: 'Category',
      company: 'Company',
      search: 'Search',
      sortBy: 'Sort By',
      lowestPrice: 'Price: Low to High',
      highestPrice: 'Price: High to Low',
      nameAZ: 'Name (A-Z)',
      nameZA: 'Name (Z-A)',
      clearFilters: 'Clear Filters',
      gridView: 'Grid View',
      listView: 'List View',
      all: 'All',
      quickView: 'Quick View',
      productsFound: 'Products found',
      freeShipping: 'Free Shipping',
    },
    
    // Single Product
    singleProduct: {
      backToProducts: 'Back to Products',
      reviews: 'reviews',
      customerReviews: 'Customer Reviews',
      noReviews: 'No reviews yet',
      orderNow: 'Order Now',
      addToCart: 'Add to Cart',
    },
    
    // Customer Form
    customerForm: {
      title: 'Delivery Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone Number',
      governorate: 'Governorate',
      city: 'City',
      selectGovernorate: 'Select Governorate',
      selectCity: 'Select City',
      phonePlaceholder: 'Enter phone number',
    },
    
    // Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      fillCart: 'Add products to your cart',
      item: 'Item',
      price: 'Price',
      quantity: 'Quantity',
      subtotal: 'Subtotal',
      total: 'Total',
      remove: 'Remove',
      clearCart: 'Clear Cart',
      continueShopping: 'Continue Shopping',
      proceedToCheckout: 'Proceed to Checkout',
      shippingFee: 'Shipping Fee',
      orderTotal: 'Order Total',
      free: 'Free',
    },
    
    // Checkout
    checkout: {
      title: 'Checkout',
      paymentMethod: 'Payment Method',
      cashOnDelivery: 'Cash on Delivery',
      placeOrder: 'Place Order',
      orderSummary: 'Order Summary',
      items: 'Items',
      shipping: 'Shipping',
      total: 'Total',
      thankYou: 'Thank You!',
      orderPlaced: 'Your order has been placed successfully',
      payOnDelivery: 'You will pay on delivery',
      redirecting: 'Redirecting to Products page',
      hello: 'Hello',
      yourTotal: 'Your total is',
    },
    
    // Orders
    orders: {
      title: 'My Orders',
      noOrders: 'No orders found',
      orderNumber: 'Order Number',
      date: 'Date',
      status: 'Status',
      total: 'Total',
      details: 'Details',
      processing: 'Processing',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
    },
    
    // About
    about: {
      title: 'Our Story',
      content: 'We are an online store specialized in providing the best products at competitive prices. We always strive to provide a unique shopping experience for our customers.',
    },
    
    // Services
    services: {
      title: 'Our Services',
      freeShipping: 'Free Shipping',
      freeShippingDesc: 'Free shipping on all orders',
      support: '24/7 Support',
      supportDesc: 'Support team always available to help you',
      quality: 'High Quality',
      qualityDesc: 'Original products with guaranteed quality',
    },
    
    // Contact
    contact: {
      title: 'Contact Us',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send',
    },
    
    // Auth
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      resetPassword: 'Reset Password',
      noAccount: "Don't have an account?",
      haveAccount: 'Already have an account?',
      signInWithGoogle: 'Sign in with Google',
      or: 'or',
    },
    
    // Footer
    footer: {
      rights: 'All Rights Reserved',
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      success: 'Operation successful',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      viewAll: 'View All',
    },
    
    // Toasts
    toasts: {
      orderSuccess: 'Order placed successfully! You will pay on delivery.',
      orderError: 'Failed to place order. Please try again.',
      addedToCart: 'Added to cart',
      removedFromCart: 'Removed from cart',
      cartCleared: 'Cart cleared',
      loginRequired: 'Please login first',
      fillAllFields: 'Please fill all fields',
    },
  },
};
